import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { t } from 'ttag';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export default function ActivityChangesTable({ changes }) {
  const classes = useStyles();

  return (
    <TableContainer>
      <Table className={classes.table} aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell>{t`Назва`}</TableCell>
            <TableCell align='right'>{t`Попередні данні`}</TableCell>
            <TableCell align='right'>{t`Поточні данні`}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {changes.map((row) => (
            <TableRow key={row.name}>
              <TableCell component='th' scope='row'>
                {row.name}
              </TableCell>
              <TableCell align='right'>{row.previous}</TableCell>
              <TableCell align='right'>{row.current}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
